<template>
    <nav id="header">
        <h1 @click="gotohome">
            <span>Elemax-Tech Enginnering</span>
            <img src="@/assets/img/logo.jpg" alt="Logo"/>
        </h1>
		<div class="menuIcon" @click="toogleMenu">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <p class="text open">Menu</p>
            <p class="text close">Close</p>
        </div>
        <ul>
            <li>
                <router-link to="/" class="linkto">Home</router-link>
            </li>
            <li>
                <router-link to="/products" class="linkto">Products</router-link>
            </li>
            <li>
                <router-link to="/services" class="linkto">Services</router-link>
            </li>
            <li v-if="check_spareparts.has_data">
                <router-link to="/spare-parts" class="linkto">Spare Parts</router-link>
            </li>
            <li>
                <router-link to="/about" class="linkto">About</router-link>
            </li>
            <li>
                <router-link to="/factory" class="linkto">Factory</router-link>
            </li>
            <li v-if="check_projects.has_data">
                <router-link to="/project-reference" class="linkto">Project Reference</router-link>
            </li>
            <li>
                <router-link to="/contact" class="linkto">Contact</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import axios from "axios";
export default {
    name: 'ContentHeader',
	data() {
		return {
			apiBase: process.env.VUE_APP_API_BASE,
			apiToken: process.env.VUE_APP_API_TOKEN,
			check_projects: { has_data: false, count: 0 },
			check_spareparts: { has_data: false, count: 0 },
			loading: true,
		}
	},
    methods: {
        gotohome() {
            if (this.$route.path !== '/') {
                this.$router.push('/');
            }
        },
		toogleMenu() {
			const header = document.getElementsByClassName('menuIcon')[0];
			const menu = document.getElementById('header').getElementsByTagName('ul')[0];
			menu.classList.toggle('active');
			header.classList.toggle('active');
		},
		async fetchData() {
		try {
				const res = await axios.get(`${this.apiBase}/api/check_projects`, {
				headers: { Authorization: `Bearer ${this.apiToken}` },
				});

				const checkspareparts = await axios.get(`${this.apiBase}/api/check_spareparts`, {
				headers: { Authorization: `Bearer ${this.apiToken}` },
				});

				this.check_projects = res.data;
				this.check_spareparts = checkspareparts.data;
			} catch (err) {
				console.error("API Error:", err);
			} finally {
				this.loading = false;
			}
		}
    },
	mounted() {
		this.fetchData();
	}
}
</script>